import { Grid, InputLabel, TextField } from '@material-ui/core'
import { PRIMARY_COLORS } from 'asterX-UI'
import React, { useRef, useState } from 'react'

import { useSnackbar } from 'notistack'

import { useSelectionStore } from 'context/SelectionStore/Manager/SelectionStoreProvider.manager'
import ActionModal from 'asterX-UI/Modals/ActionModal'
import { BonusService } from 'lib/api/services/bonus.service'

export const UnFrozeModal = ({
  title,
  labelConfirm,
  open,
  onClose,
  onCancel,
  getBonuses = () => {}
}) => {
  const intervalRef = useRef(null)
  const { enqueueSnackbar } = useSnackbar()
  const {
    store: { sale },
    funcs
  } = useSelectionStore()

  const [otpCode, setOtpCode] = useState(null)
  const [timer, setTimer] = useState(0)
  const [isLoading, setIsLoading] = useState(false)

  const clearUnfrozeBonus = async () => {
    setOtpCode(null)
    setTimer(0)
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
  }

  const startTimer = () => {
    let counter = 15
    intervalRef.current = setInterval(() => {
      setTimer(counter)
      if (counter === 0) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      } else {
        counter--
      }
    }, 1000)
  }

  const unfrozeBonus = async () => {
    try {
      if (!otpCode || isLoading) {
        enqueueSnackbar('Введите код!', { variant: 'warning' })
        return
      }
      const phoneNumber = sale?.client?.phoneNumber?.toNum()
      const data = {
        phoneNumber: String(phoneNumber),
        otpCode,
        workListId: sale?.globalId,
        vin: sale?.selectedCarsForSale?.[0]?.vin,
        projectCode: 'CS_AMP'
      }

      const res = await BonusService.unfrozeBonus(data)
      if (res?.data) {
        enqueueSnackbar('Успешно!', { variant: 'success' })
        await funcs.sendDiscountValue({ bonus: 0 }, true)
        getBonuses()
        handleClose()
      } else {
        enqueueSnackbar(`Произошла ошибка! ${res?.msg || res?.message || ''}`, {
          variant: 'error'
        })
      }
    } catch (error) {
      console.error(error)
    }
  }

  const postOtpCode = async phoneNumber => {
    if (!phoneNumber) {
      enqueueSnackbar('Нет номера', { variant: 'warning' })
      return
    }
    if (timer > 0) {
      enqueueSnackbar(`Доступно через ${timer} сек`, { variant: 'warning' })
      return
    }
    setIsLoading(true)
    try {
      const res = await BonusService.sendOtpCode(phoneNumber?.toNum())
      if (res?.data) {
        enqueueSnackbar('Код успешно отправлен!', { variant: 'success' })
        startTimer(setTimer)
      } else {
        enqueueSnackbar('Произошла ошибка! Повторите попытку!', {
          variant: 'error'
        })
      }
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleClose = () => {
    onClose()
    clearUnfrozeBonus()
  }
  const handleCancel = () => {
    onCancel()
    clearUnfrozeBonus()
  }

  return (
    <ActionModal
      title={title}
      open={open}
      labelConfirm={labelConfirm}
      onCancel={handleCancel}
      onClose={handleClose}
      onConfirm={unfrozeBonus}
    >
      <Grid
        item
        container
        display="flex"
        justifyContent="flex-end"
        xs={12}
        md={12}
        spacing={2}
      >
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            value={otpCode || ''}
            onChange={e => setOtpCode(e.target.value)}
            label={'Код...'}
            placeholder={'Код'}
          />
          <InputLabel shrink>
            Код подтверждения будет отправлен на номер телефона клиента
            <span
              onClick={() => postOtpCode(sale?.client?.phoneNumber)}
              style={{
                color: PRIMARY_COLORS[700],
                cursor: 'pointer',
                fontSize: 18,
                fontWeight: 500
              }}
            >
              {`${
                timer > 0 ? ` отправить еще раз ${timer} сек` : ' отправить код'
              }`}
            </span>
          </InputLabel>
        </Grid>
      </Grid>
    </ActionModal>
  )
}
